export const SIGN_IT_DESCRIPTION =
	'Simplify e-signatures with SignIT, powered by DocuSign. Prepare, send, and track signing packages securely and effortlessly, with pay-per-use pricing for maximum flexibility.';
